/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_nativeKeysIn.js
 ** module id = ./node_modules/lodash/_nativeKeysIn.js
 ** module chunks = 0
 **/